export default __webpack_public_path__ + "47230b6e91fb4dceed8d5f6c127649d1.svg";